import { Empty } from "antd";
import { useTranslation } from "react-i18next";

export function NoData({ main }: { main?: boolean }) {
  const { t } = useTranslation();

  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={
        main ? (
          <>
            <h3>{t("noData")}</h3>
            <div
              style={{
                width: "420px",
                height: "180px",
                margin: "0 auto 0 auto",
              }}
            />
          </>
        ) : (
          t("noData")
        )
      }
    />
  );
}
